import React, { useState } from "react";
import { toast } from "react-toastify";
import { Table, Modal, Button } from "antd";
import Magnifier from "react-magnifier";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CAMERAICON from "../../Assets/camera.png";
import ALERTICON from "../../Assets/alert.png";
import STATUSICON from "../../Assets/clipboard.png";
import IMAGEICON from "../../Assets/picture.png";
import DATEICON from "../../Assets/schedule.png";
import CLOCKICON from "../../Assets/clock.png";
import NOTFOUNDICON from "../../Assets/not-found.png";
import DOWNLOADICON from "../../Assets/download.png";
import TYPEICON from "../../Assets/typing.png";
import TATICON from "../../Assets/delivery.png";
import PERSONICON from "../../Assets/man.png";
import StatusModalPopup from "./StatusModalPopup";
import {
  editAlertManual,
  manualcloseStatus,
  manualcommentList,
  postCommentForManual,
  updateAlertStatusToInProgressForManualAlerts,
} from "../../services/AlertsTable";
//React Icons
import { CgCalendarDates } from "react-icons/cg";
import { FaRegClock } from "react-icons/fa";
import { IoAlert } from "react-icons/io5";
import { FaCameraRetro } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";
import { ImLocation2 } from "react-icons/im";
import { TbReport } from "react-icons/tb";

const AddAlertTable = ({
  tableData,
  imageModalOpen,
  handleOpenImageModal,
  handleCloseImageModal,
  Image,
  setImage,
  name,
  email,
  getManualAlertsList,
  alertsAssignedMailsoptions,
  esscalationEmailsoptions,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalRecord, setModalRecord] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [statusValue, setStatusValue] = useState("");
  const [alertCloseDetails, setAlertCloseDetails] = useState({});
  const [alertsAssignedMailsSelected, setalertsAssignedMailsSelected] =
    useState([]);
  const [esscalationEmailsSelected, setesscalationEmailsSelected] = useState(
    []
  );
  const [statusOptionSelected, setStatusoptionSelected] = useState();

  const handleCommentChange = (e) => {
    setCommentText(e.target.value);
  };

  const handleChangeAletsAssignedEmails = (selected) => {
    setalertsAssignedMailsSelected(selected);
  };
  const handleChangeEsscalationEmail = (selected) => {
    setesscalationEmailsSelected(selected);
  };

  const handleCommentClick = async (modalRecord) => {
    let { _id } = modalRecord;
    // Ensure comments is an array before updating the state
    if (comments !== null) {
      setComments([
        {
          date: new Date().toDateString(),
          time: new Date().toLocaleTimeString().split(" ")[0],
          comment: commentText,
          name: name,
        },
        ...(comments || []), // Default to an empty array if comments is not iterable
      ]);
      await postCommentForManual({ id: _id, comments, commentText, name });
    } else {
      setComments([
        {
          date: new Date().toDateString(),
          time: new Date().toLocaleTimeString().split(" ")[0],
          comment: commentText,
          name: name,
        },
      ]);
      await postCommentForManual({ id: _id, comments, commentText, name });
    }
    // Clear the comment text input
    setCommentText("");
  };

  const getComments = async (record) => {
    let { _id } = record;
    let commentsList = await manualcommentList(_id);
    setComments(commentsList.data.data);
  };

  const confirm = async (modalRecord) => {
    let { _id, alertsAssignedMails } = modalRecord;
    let commentsList = await manualcommentList(_id);
    let commentsArray = commentsList?.data?.data;
    try {
      if (commentsArray?.length == 0) {
        return toast("Status cannot be close without comments.");
      } else {
        if (!alertsAssignedMails?.includes(email)) {
          let assignedMails = Array.isArray(alertsAssignedMails)
            ? alertsAssignedMails.join(", ")
            : alertsAssignedMails;
          toast(
            `You cannot close this status. This alert is not assigned to ${email}. ` +
              `Only ${
                Array.isArray(alertsAssignedMails)
                  ? alertsAssignedMails.join(", ")
                  : alertsAssignedMails
              } can close this alert.`
          );
        } else {
          setStatusValue("Close");
          let updateAlertResponse = await manualcloseStatus({
            _id,
            name,
          });
          if (updateAlertResponse.status) {
            toast(
              "Alert Status Updated.An Email has been to your mail regarding it."
            );
            setModalOpen(false);
            setAlertCloseDetails(...updateAlertResponse.data.data);
          } else {
            toast("Alert Status Updation failed");
          }
          setModalOpen(false);
        }
      }
    } catch (error) {}
  };
  const inProgresConfirm = async (modalRecord) => {
    let { _id, alertsAssignedMails } = modalRecord;
    let commentsList = await manualcommentList(_id);
    let commentsArray = commentsList?.data?.data;
    try {
      if (commentsArray.length == 0) {
        return toast("Status cannot be move to in progress without comments.");
      } else {
        if (!alertsAssignedMails?.includes(email)) {
          let assignedMails = Array.isArray(alertsAssignedMails)
            ? alertsAssignedMails.join(", ")
            : alertsAssignedMails;
          toast(
            `You cannot move this status to in progress. This alert is not assigned to ${email}. ` +
              `Only ${
                Array.isArray(alertsAssignedMails)
                  ? alertsAssignedMails.join(", ")
                  : alertsAssignedMails
              } can move this alert to in-progress.`
          );
        } else {
          setStatusValue("InProgress");
          let updateAlertResponse =
            await updateAlertStatusToInProgressForManualAlerts({
              _id,
            });
          getManualAlertsList();
          if (updateAlertResponse == true) {
            toast(
              "Alert Status Updated. An Email has been to your mail regarding it."
            );
            setModalOpen(false);
          } else {
            toast("Alert Status Updation failed");
          }
        }
      }
    } catch (error) {}
  };

  const handleUpdate = async (id) => {
    console.log(
      "Update Id ---> ",
      id,
      alertsAssignedMailsSelected.length,
      esscalationEmailsSelected.length
    );
    if (
      alertsAssignedMailsSelected?.length == 0 ||
      esscalationEmailsSelected?.length == 0
    ) {
      toast("Assign To And Email To Is Required");
    } else {
      let params = {
        id,
        alertsAssignedMails: alertsAssignedMailsSelected.map(
          (item) => item.label
        ),
        esscalationEmails: esscalationEmailsSelected.map((item) => item.label),
      };
      let editResponse = await editAlertManual(params);
      let {
        status,
        message: { data },
      } = editResponse;
      if (status == 201) {
        toast(data);
        setModalOpen(false);
        getManualAlertsList();
      }
      console.log("Edit Response ----> ", editResponse);
    }
  };

  const cancel = () => setModalOpen(false);
  const columns = [
    {
      title: (
        <span className="flex items-center gap-2">
          <CgCalendarDates className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Date</span>
        </span>
      ),
      key: "date",
      dataIndex: "date",
      align: "left",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      onFilter: (value, record) => record.date.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div className="p-2">
          <input
            placeholder="Search Date"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            className="w-full p-2 border"
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            className="w-full mt-1"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && clearFilters(); // Clears the filter applied to the column
              setSelectedKeys([]); // Clears the filter input field
              confirm(); // Confirms and updates the table
            }}
            className="w-full mt-1"
          >
            Reset
          </Button>
        </div>
      ),
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <FaRegClock className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Time</span>
        </span>
      ),
      key: "time",
      dataIndex: "time",
      align: "left",
      sorter: (a, b) => a.time.localeCompare(b.time),
      onFilter: (value, record) => record.time.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div className="p-2">
          <input
            placeholder="Search Time"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            className="w-full p-2 border"
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            className="w-full mt-1"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && clearFilters(); // Clears the filter applied to the column
              setSelectedKeys([]); // Clears the filter input field
              confirm(); // Confirms and updates the table
            }}
            className="w-full mt-1"
          >
            Reset
          </Button>
        </div>
      ),
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <IoAlert className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Alert</span>
        </span>
      ),
      key: "alert",
      dataIndex: "alert",
      align: "left",
      sorter: (a, b) => a.alert.localeCompare(b.alert),
      onFilter: (value, record) => record.alert.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div className="p-2">
          <input
            placeholder="Search Alert"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            className="w-full p-2 border"
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            className="w-full mt-1"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && clearFilters(); // Clears the filter applied to the column
              setSelectedKeys([]); // Clears the filter input field
              confirm(); // Confirms and updates the table
            }}
            className="w-full mt-1"
          >
            Reset
          </Button>
        </div>
      ),
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <FaCameraRetro className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Camera</span>
        </span>
      ),
      key: "camera",
      dataIndex: "camera",
      align: "left",
      sorter: (a, b) => a.camera.localeCompare(b.camera),
      onFilter: (value, record) => record.camera.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div className="p-2">
          <input
            placeholder="Search Date"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            className="w-full p-2 border"
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            className="w-full mt-1"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && clearFilters(); // Clears the filter applied to the column
              setSelectedKeys([]); // Clears the filter input field
              confirm(); // Confirms and updates the table
            }}
            className="w-full mt-1"
          >
            Reset
          </Button>
        </div>
      ),
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <FaImage className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Image</span>
        </span>
      ),
      key: "image",
      dataIndex: "image",
      render: (_, record) => (
        <img
          src={record.image}
          alt="_Image"
          className="w-48 h-24 cursor-pointer border border-sky-300 p-2 rounded-lg"
           onClick={function () {
                handleOpenImageModal();
                setImage(record.image);
              }}
        />
      ),
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <TbReport className="text-xl text-teal-700" />
          <span className="text-slate-700 text-lg font-normal">Status</span>
        </span>
      ),
      key: "status",
      dataIndex: "status",
      render: (status, record) => (
        <Button
          type="primary"
          style={{ backgroundColor: getStatusColor(status), height: "auto" }}
          onClick={() => {
            setModalOpen(true);
            setModalRecord(record);
          }}
        >
          {status.toUpperCase()}
        </Button>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
      onFilter: (value, record) => record.status.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div className="p-2">
          <input
            placeholder="Search Status"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            className="w-full p-2 border"
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            className="w-full mt-1"
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && clearFilters(); // Clears the filter applied to the column
              setSelectedKeys([]); // Clears the filter input field
              confirm(); // Confirms and updates the table
            }}
            className="w-full mt-1"
          >
            Reset
          </Button>
        </div>
      ),
    },
  ];
  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
        return "#BA5D4F";
      case "InProgress":
        return "#e3b505";
      case "Assigned":
        return "teal";
      case "Close":
        return "#519872";
      default:
        return "#ddd";
    }
  };

  return (
    <>
      <div className="border border-slategray-400 rounded-xl p-2">
        <Table columns={columns} dataSource={tableData} />
      </div>
      <StatusModalPopup
        modalOpen={modalOpen}
        cancel={cancel}
        modalRecord={modalRecord}
        // Pass all other necessary props here
        alertsAssignedMailsoptions={alertsAssignedMailsoptions}
        esscalationEmailsoptions={esscalationEmailsoptions}
        handleChangeAletsAssignedEmails={handleChangeAletsAssignedEmails}
        handleChangeEsscalationEmail={handleChangeEsscalationEmail}
        statusOptionSelected={statusOptionSelected}
        handleUpdate={handleUpdate}
        handleCommentChange={handleCommentChange}
        commentText={commentText}
        handleCommentClick={handleCommentClick}
        confirm={confirm}
        inProgresConfirm={inProgresConfirm}
        PERSONICON={PERSONICON}
        DATEICON={DATEICON}
        CLOCKICON={CLOCKICON}
        ALERTICON={ALERTICON}
        CAMERAICON={CAMERAICON}
        TATICON={TATICON}
        TYPEICON={TYPEICON}
        STATUSICON={STATUSICON}
        comments={comments}
        status={statusValue}
      />

      {/* Modal for Image */}
      <Modal
        open={imageModalOpen}
        centered
        onCancel={handleCloseImageModal}
        footer={null}
      >
        <Box>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Image
          </Typography>
          {Image ? (
            <>
              <Magnifier src={Image} mgShape="square" alt="_blank" />
              <a href={Image}>
                <img
                  src={DOWNLOADICON}
                  style={{ width: "5vh", height: "5vh" }}
                  className="my-3"
                  alt={NOTFOUNDICON}
                />
                Download
              </a>
            </>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={NOTFOUNDICON}
                alt="_blank"
                style={{ width: "15vh", height: "15vh" }}
              />
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default AddAlertTable;
